// extracted by mini-css-extract-plugin
module.exports = {"container":"Fd","timeTop":"Gd","timeCountdown":"Hd","cta":"Id","disabled":"Jd","product":"Kd"};